import api from './api';
import { Mitarbeiter, MitarbeiterProfilDaten } from '../types';

export const authService = {
  login: async (email: string, password: string, totp_code?: string) => {
    const response = await api.post('/auth/login', { email, password, totp_code });
    return response.data;
  },

  logout: async () => {
    const response = await api.post('/auth/logout');
    return response.data;
  },

  getMe: async (): Promise<Mitarbeiter> => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  patchProfil: async (data: Partial<MitarbeiterProfilDaten>): Promise<Mitarbeiter> => {
    const response = await api.patch('/auth/me/profil', data);
    return response.data;
  },

  uploadAvatar: async (file: File): Promise<Mitarbeiter> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/auth/me/avatar', formData);
    return response.data;
  },

  deleteAvatar: async (): Promise<Mitarbeiter> => {
    const response = await api.delete('/auth/me/avatar');
    return response.data;
  },

  setup2FA: async () => {
    const response = await api.post('/auth/2fa/setup');
    return response.data;
  },

  verify2FA: async (secret: string, code: string) => {
    const response = await api.post('/auth/2fa/verify', { secret, code });
    return response.data;
  },

  disable2FA: async () => {
    const response = await api.delete('/auth/2fa');
    return response.data;
  },

  setRestrictedPassword: async (currentPassword: string, newPassword: string) => {
    const response = await api.put('/auth/me/restricted-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });
    return response.data;
  },

  removeRestrictedPassword: async () => {
    const response = await api.delete('/auth/me/restricted-password');
    return response.data;
  },

  changePassword: async (currentPassword: string, newPassword: string) => {
    const response = await api.post('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });
    return response.data;
  },

  requestPasswordReset: async (email: string) => {
    const response = await api.post('/auth/password-reset/request', { email });
    return response.data;
  },

  confirmPasswordReset: async (token: string, newPassword: string) => {
    const response = await api.post('/auth/password-reset/confirm', {
      token,
      new_password: newPassword,
    });
    return response.data;
  },
};
